<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>미납주차요금</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">미납주차요금</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">미납요금 조회/결제</p>
          <ul class="depth">
            <li><router-link to="/unpaidinfo" title="미납요금 납부안내">미납요금 납부안내</router-link></li>
            <li>
              <router-link to="/lookupunpaid" title="미납요금 조회/결제">미납요금 조회/결제</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">미납 주차요금 결제</h3>

        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                미납주차요금 결제 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 120px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>
                    <strong class="colorType blue">{{ unpaidInfo.carNo }}</strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">전체 미납 건수</th>
                  <td>{{ unpaidInfo.totalCnt }}건</td>
                </tr>
                <tr>
                  <th scope="row">전체 미납주차료</th>
                  <td>{{ unpaidInfo.totalUnpaidAmt | comma }}원</td>
                </tr>
                <tr>
                  <th scope="row">전체 가산금</th>
                  <td>{{ unpaidInfo.totalAddAmt | comma }}원</td>
                </tr>
                <tr>
                  <th scope="row">미납총액</th>
                  <td>
                    <strong class="colorType blue">{{ unpaidInfo.totalSumAmt | comma }}원</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
        </article>
        <article class="btnArea">
          <button class="btn gray" @click="$router.push({name:'lookupunpaid', params:{carNo : unpaidInfo.carNo}})">취소</button>
          <button class="btn blue" @click="paymentBtn">결제</button>
        </article>
      </div>
    </section>

    <!-- 스마트로 결제 폼 -->
    <form id="tranMgr" name="tranMgr" method="post">
      <input type="hidden" name="PayMethod" v-model="smartropayParms.PayMethod" />
      <input type="hidden" name="GoodsCnt" v-model="smartropayParms.GoodsCnt" />
      <input type="hidden" name="GoodsName" v-model="smartropayParms.goodsName" />
      <input type="hidden" name="Amt" v-model="smartropayParms.amount" />
      <input type="hidden" name="Moid" v-model="smartropayParms.moid" />
      <input type="hidden" name="Mid" v-model="smartropayParms.mid" />
      <input type="hidden" name="ReturnUrl" v-model="smartropayParms.returnUrl" />
      <input type="hidden" name="BuyerName" v-model="smartropayParms.buyerName" />
      <input type="hidden" name="BuyerTel" v-model="smartropayParms.buyerTel" />
      <input type="hidden" name="BuyerEmail" v-model="smartropayParms.BuyerEmail" />
      <input type="hidden" name="MallIp" v-model="smartropayParms.MallIp" />
      <input type="hidden" name="EncryptData" v-model="smartropayParms.encryptData" />
      <input type="hidden" name="EdiDate" v-model="smartropayParms.ediDate" />
      <input type="hidden" name="TaxAmt" v-model="smartropayParms.TaxAmt" />
      <input type="hidden" name="TaxFreeAmt" v-model="smartropayParms.TaxFreeAmt" />
      <input type="hidden" name="VatAmt" v-model="smartropayParms.VatAmt" />
    </form>

    <form id="approvalForm" name="approvalForm" method="post">
      <input type="hidden" id="Tid" name="Tid" />
      <input type="hidden" id="TrAuthKey" name="TrAuthKey" />
    </form>
    <!-- 스마트로 결제 폼 -->
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      unpaidInfo: {
        inOutIds: '',
        carNo: '',
        totalCnt: 0,
        totalSumAmt: 0,
        totalUnpaidAmt: 0,
        totalAddAmt: 0,
        isOffSt: true,
        items: [],
      },
      unpaidParams: {},
      smartropayParms: {},
    };
  },

  mounted() {
    const data = this.$route.params.data;
    const sttus = this.$route.query.r;

    if (sttus == 'true') {
      alert('결제가 정상적으로 처리되었습니다.');
      this.$router.push('lookupunpaid');
      return;
    } else if(sttus == 'false') {
      alert('결제 처리 중 오류가 발생했습니다.');
      this.$router.push('lookupunpaid');
      return;
    }
    
    if (data) {
      this.unpaidInfo.inOutIds = data.inOutIds;
      this.unpaidInfo.carNo = data.carNo;
      this.unpaidInfo.totalSumAmt = data.totalSumAmt;
      this.unpaidInfo.totalUnpaidAmt = data.totalUnpaidAmt;
      this.unpaidInfo.totalAddAmt = data.totalAddAmt;
      this.unpaidInfo.totalCnt = data.totalCnt;
      this.isOffSt = data.isOffSt;

      if(!this.isOffSt) {
        this.unpaidInfo.items = data.items;
      }
    }
  },

  methods: {
    
    async paymentBtn() {
      
      if (this.unpaidInfo.inOutIds == '') {
        alert('결제 정보가 없습니다.');
        this.$router.push('/lookupunpaid');
        return;
      }
      
      let apiParams = new FormData();
      const memberInfoId = this.$store.state.empNo ? this.$store.state.empNo : this.unpaidInfo.carNo;
      
      apiParams.append('amount', this.unpaidInfo.totalSumAmt);
      apiParams.append('inOutId', this.unpaidInfo.inOutIds);
      apiParams.append('payCategory', this.isOffSt ? 'DEFAULT' : 'STREET');
      apiParams.append('isStatus', false);
      apiParams.append('memberInfoId', memberInfoId);
      apiParams.append('carNumber', this.unpaidInfo.carNo);
      
      if(!this.isOffSt) {
          apiParams.append('streetItems', JSON.stringify(this.unpaidInfo.items));
      }

      const res = await axios('post', '/api/smartropay/payment', apiParams);
      
      const { ediDate = '', encryptData = '', mid = '', amount = '', paymentId = '' } = res.data.result;
      const RETURN_URL = `${process.env.VUE_APP_DOMAIN}/api/smartropay/callApproval/unpaidview/${paymentId}`;

      const TaxFreeAmt = 0;
      const tmp = amount / 1.1;
      const VatAmt = Math.floor(amount - tmp);
      const TaxAmt = amount - VatAmt;

      const buyerName = this.$store.state.empNm ? this.$store.state.empNm : this.unpaidInfo.carNo;
      const buyerTel = this.$store.state.empMobile ? this.$store.state.empMobile : '01000000000';
      
      this.smartropayParms = {
        goodsName: `미납_${buyerName}_${amount}원`,
        amount: amount,
        moid: paymentId,
        mid: mid,
        returnUrl: RETURN_URL,
        StopUrl: RETURN_URL,
        buyerName: buyerName,
        buyerTel: buyerTel,
        encryptData: encryptData,
        ediDate: ediDate,
        TaxAmt: TaxAmt,
        VatAmt: VatAmt,
        TaxFreeAmt: TaxFreeAmt,
        PayMethod: 'CARD',
        GoodsCnt: 1,
        BuyerEmail: 'noname@smartro.co.kr',
        MallIp: '211.57.44.13',
      };

      await smartropay.init({
        mode: process.env.VUE_APP_SMARTRO_INIT,
      });

      await smartropay.payment({
        FormId: 'tranMgr',
        Callback: function (res) {
          var approvalForm = document.approvalForm;
          approvalForm.Tid.value = res.Tid;
          approvalForm.TrAuthKey.value = res.TrAuthKey;
          approvalForm.action = RETURN_URL;
          approvalForm.submit();
        },
      });
    },
  },
};
</script>
